import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzfmumuf73: FaireProductEntity = {
  token: "p_zzfmumuf73",
  type: "product",
  name: "SLEEVELESS V-NECK STRIPED SWEATER MIDI DRESS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/2423875ac086decf630735903edc5f44a0ee11773331df644f5bef76a9e86831.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c4bfbfff8c4deb7211c7cc230568fb0ae785eadd3a1bcbcc26d2baf61732148.jpeg",
    "https://cdn.faire.com/fastly/204a1f051da1c005b7b6b5529b3e6874e522e96aa7bec89da0905473edaf0936.jpeg",
    "https://cdn.faire.com/fastly/a30291b7ad5d414d3fd019a812039dfedf8f4edad0363cef414357333a6c1948.jpeg",
    "https://cdn.faire.com/fastly/6672eea8cb129609ffac70f522ef86dbdd7784ecef5d87705540dc8932c89a85.jpeg",
  ],
  priceDollars: 192,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 384,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:14.173Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
